"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var components_1 = require("./components");
require("./Grid.css");
function Grid(_a) {
    var children = _a.children, _b = _a.fluid, fluid = _b === void 0 ? false : _b, _c = _a.spacing, spacing = _c === void 0 ? "base" : _c, _d = _a.maxWidth, maxWidth = _d === void 0 ? 1200 : _d;
    var className = (0, classnames_1.default)("nimbus--grid", "nimbus--grid--spacing-".concat(spacing));
    return (React.createElement("div", { style: { maxWidth: !fluid && maxWidth ? "".concat(maxWidth, "px") : "100%" }, className: className }, children));
}
Grid.Row = components_1.Row;
Grid.Column = components_1.Column;
exports.default = Grid;
//# sourceMappingURL=Grid.js.map